import { gsap } from 'gsap';
import Player from '@vimeo/player';

function mediaBanner() {
  const els = document.querySelectorAll('.js-media-banner');

  if (!els.length) return;

  const handleClick = ({
    image,
    iframe,
    button,
    player,
  }: {
    image: HTMLImageElement;
    iframe: HTMLIFrameElement;
    button: HTMLButtonElement;
    player: Player;
  }) => {
    iframe.setAttribute('tabindex', null);
    gsap.to([image, button], {
      opacity: 0,
      pointerEvents: 'none',
    });
    player.play();
    iframe.focus();
  };

  els.forEach(el => {
    const button = el.querySelector<HTMLButtonElement>('.media-banner__button');
    const image = el.querySelector<HTMLImageElement>('.media-banner__image');
    const iframe = el.querySelector<HTMLIFrameElement>('.media-banner__iframe');

    if (!iframe || !button) return;
    iframe.setAttribute('tabindex', '-1');

    const player = new Player(iframe);

    button.addEventListener('click', () =>
      handleClick({ image, iframe, button, player })
    );
  });
}
mediaBanner();
